import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Section3.css";
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";
import { BsSendFill } from "react-icons/bs";

export function Section3() {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        mobile: "",
        projectDetails: ""
    });


    const handleSubmit = (e) => {
        e.preventDefault();


        const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
        const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
        const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

        const templateParams = {
            fullName: formData.fullName,
            email: formData.email,
            mobile: formData.mobile,
            projectDetails: formData.projectDetails,
            to_name: "Suresh Paliwal",
        };


        emailjs.send(serviceID, templateID, templateParams, publicKey)
            .then((response) => {
                console.log("Email sent successfully!", response.status, response.text);
            })
            .catch((error) => {
                console.error("Email sending failed:", error);
            });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div className="contact-section" id="contact">
            <div className="contact-content">
                <div className="quote-section">
                    <h2>Let's Build Something Amazing Together</h2>
                    <p className="quote">"Every great design begins with an even better story"</p>
                </div>

                <div className="form-container">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                name="fullName"
                                placeholder="Full Name"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="mobile"
                                    placeholder="Mobile Number"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <textarea
                                name="projectDetails"
                                placeholder="Tell me about your project idea..."
                                value={formData.projectDetails}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button type="submit" className="submit-btn">
                            Send Message <BsSendFill />
                        </button>
                    </form>

                </div>

                <div className="contact-links">
                    <a href="https://github.com/devilisback100" target="_blank" rel="noopener noreferrer">
                        <FaGithub /> <span className="link-text">GitHub</span>
                    </a>
                    <a href="https://www.linkedin.com/in/suresh-paliwal-a75a41266/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin /> <span className="link-text">LinkedIn</span>
                    </a>
                    <a href="tel:+1234567890">
                        <FaPhone /> <span className="link-text">Call Me</span>
                    </a>
                    <a href="mailto:sureshpaliwal357@gmail.com">
                        <FaEnvelope /> <span className="link-text">Email</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Section3;
